import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-grid-container',
  styleUrls: ['./grid-container.component.scss'],
  templateUrl: './grid-container.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridContainerComponent {
  @HostBinding('class')
  readonly cssClass = 'grid-container';
}
